import { render, staticRenderFns } from "./KanbanCommentModal.vue?vue&type=template&id=74b6a2c5&scoped=true&"
import script from "./KanbanCommentModal.vue?vue&type=script&lang=js&"
export * from "./KanbanCommentModal.vue?vue&type=script&lang=js&"
import style0 from "./KanbanCommentModal.vue?vue&type=style&index=0&id=74b6a2c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b6a2c5",
  null
  
)

export default component.exports